'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Prefixer2 = require('./Prefixer');

var _Prefixer3 = _interopRequireDefault(_Prefixer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2015/12/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var BcdPrefixer = function (_Prefixer) {
    _inherits(BcdPrefixer, _Prefixer);

    function BcdPrefixer(nDigits) {
        _classCallCheck(this, BcdPrefixer);

        var _this = _possibleConstructorReturn(this, (BcdPrefixer.__proto__ || Object.getPrototypeOf(BcdPrefixer)).call(this, nDigits));

        _this.nDigits = nDigits;
        return _this;
    }

    _createClass(BcdPrefixer, [{
        key: 'encodeLength',
        value: function encodeLength(length, b) {
            for (var i = this.getPackedLength() - 1; i >= 0; i--) {
                var twoDigits = length % 100;
                length /= 100;
                b[i] = (twoDigits / 10 << 4) + twoDigits % 10;
            }
        }
    }, {
        key: 'decodeLength',
        value: function decodeLength(b, offset) {
            var len = 0;
            for (var i = 0; i < Math.floor((this.nDigits + 1) / 2); i++) {
                len = 100 * len + ((b[offset + i] & 0xF0) >> 4) * 10 + (b[offset + i] & 0x0F);
            }
            return len;
        }
    }, {
        key: 'getPackedLength',
        value: function getPackedLength() {
            return this.nDigits + 1 >> 1;
        }
    }]);

    return BcdPrefixer;
}(_Prefixer3.default);

BcdPrefixer.LL = new BcdPrefixer(2);
BcdPrefixer.LLL = new BcdPrefixer(3);
exports.default = BcdPrefixer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/BcdPrefixer.js
// module id = 9
// module chunks = 0